import {FacebookFilled, InstagramFilled, MailOutlined, PhoneOutlined, WhatsAppOutlined} from '@ant-design/icons';
import {Divider} from 'antd';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const FooterScreen = ({data}) => {
  return (
    <div
      id={'footer'}
      className={'w-full flex flex-col justify-center items-center px-4 lg:px-20 py-6 mt-auto'}
    >
      <div className={'w-full max-w-7xl'}>
        <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-base w-full'}>
          {/* Logo */}
          <div className={'flex flex-col items-center lg:items-start'}>
            <div className={'w-[150px] lg:w-[240px] lg:h-32 h-10'}>
              <Link to={'/'}>
                <img src={data.image} alt={'logo'} className={'h-full w-full object-contain'}  />
              </Link>
            </div>
          </div>

          {/* Contact us */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold'}>Contact Us</p>
            <div className={'flex items-center gap-2 mb-2'}>
              <PhoneOutlined rotate={90} className={'text-blue-700 text-lg'} />
              <span className={'flex flex-col'}>
                <p>{data.phone_no1}</p>
                <p>{data.phone_no2}</p>
                <p>{data.phone_no3}</p>
              </span>
            </div>
            <div className={'flex items-center gap-2'}>
              <MailOutlined className={'text-red-700 text-lg'} />
              <span>{data.email}</span>
            </div>
          </div>

          {/* Location */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold'}>Location</p>
            <p className={'text-center lg:text-left'}>{data.location}</p>
          </div>

          {/* Social media links */}
          <div className={'flex flex-col lg:items-start items-center'}>
            <p className={'lg:text-xl text-lg md:mb-3 font-bold '}>Follow Us</p>
            <div className={'flex gap-4'}>
              <Link to={data.facebookLink} target={'_blank'}>
                <FacebookFilled className={'text-[#0c60cd] text-2xl'} />
              </Link>
              <Link to={data.instagramLink} target={'_blank'}>
                <InstagramFilled className={'text-[#d62976] text-2xl'} />
              </Link>
              <Link to={data.whatsappLink} target={'_blank'}>
                <WhatsAppOutlined className={'text-[#357851] text-2xl'} />
              </Link>
            </div>
          </div>
        </div>

        {/* Divider */}
        <Divider className={'my-6'} />

        {/* Bottom row */}
        <div className={'flex lg:flex-row flex-col justify-between items-center gap-2 text-sm text-center'}>
          <div>© {new Date().getFullYear()} All rights reserved - Volume nine manufacturing pvt. Ltd</div>
          <div>Powered By - Ascensify  </div>
        </div>
      </div>
    </div>
  );
};

FooterScreen.propTypes = {
  data: PropTypes.shape,
};

export default FooterScreen;
